import { TAXONOMY_DISPLAY } from '@archetelos/lib';
import { formatArticleDate } from '@archetelos/lib/date';
import { Link } from '@tanstack/react-router';

import { BookmarkButton } from './BookmarkButton';

import { contentHref } from '@/lib/contentHref';
import type { RecommendationRow } from '@/lib/queries/subscriber';

export function ContentCard({ item }: { item: RecommendationRow }) {
  const tradition = item.tradition_tags?.[0];
  return (
    <article className="group relative flex flex-col overflow-hidden rounded-lg border border-ink/10 bg-parchment">
      <div className="absolute right-2 top-2 z-10 rounded-md bg-parchment/90">
        <BookmarkButton contentId={item.content_id} />
      </div>
      <Link to={contentHref(item.type, item.slug)} className="flex flex-1 flex-col">
        {item.cover_image_url && (
          <div className="aspect-[16/10] overflow-hidden bg-ink/5">
            <img
              src={item.cover_image_url}
              alt={item.cover_image_alt ?? item.title}
              loading="lazy"
              className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-[1.03]"
            />
          </div>
        )}
        <div className="flex flex-1 flex-col p-5">
          {tradition && (
            <span className="font-sans text-[0.7rem] uppercase tracking-[0.12em] text-slate">
              {TAXONOMY_DISPLAY[tradition] ?? tradition}
            </span>
          )}
          <h3 className="mt-2 font-serif text-lg leading-snug text-ink group-hover:text-oxblood">
            {item.title}
          </h3>
          {item.excerpt && (
            <p className="mt-2 line-clamp-2 font-sans text-sm text-ink/70">{item.excerpt}</p>
          )}
          <p className="mt-auto pt-4 font-sans text-xs text-ink/50">
            {item.type === 'video' ? 'Video' : 'Essay'}
            {item.published_at && ` · ${formatArticleDate(new Date(item.published_at))}`}
          </p>
        </div>
      </Link>
    </article>
  );
}
